<template>
    <div>

        <uzhnet-back-button @click="$router.push('/main')" />

        <div class="delete-profile-view">
            <div class="header-block">
                <div class="barrier">
                    <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M119 1H114L125 11H130L119 1Z" fill="#CACACA" stroke="#CACACA"/>
                        <path d="M114 1H0" stroke="#CACACA"/>
                    </svg>
                </div>
                <div class="label">
                    {{ $t('profileSelectingPage.profilesHeader') }}
                </div>
                <div class="barrier">
                    <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 11H18L7 1H2L13 11Z" fill="#CACACA" stroke="#CACACA"/>
                        <path d="M18 11H132" stroke="#CACACA"/>
                    </svg>
                </div>
            </div>

            <div class="delete-profile-card">
                <uzhnet-card-danger class="w-92">
                    <div class="delete-profile-form">
                        <div>
                            <img src="@/assets/images/delete-profile.svg" alt="">
                            <div class="delete-card-content">
                                <div class="delete-card-content__login">{{ store.profile_for_deletion }}</div>
                                <div class="delete-card-content__address">{{ locale == 'en' ? transliterate(store.profile_for_deletion_address) : store.profile_for_deletion_address }}</div>
                            </div>
                        </div>
                    </div>
                </uzhnet-card-danger>

                <div class="delete-profile-card__info">
                    {{ $t('deleteProfilePage.trulyWantDelete') }}<br>{{ $t('deleteProfilePage.profileFromApp') }}
                </div>
            </div>

            <div class="profile-delete-button">
                <uzhnet-button-danger class="w-92" @click="deleteSelectedProfile" :label="$t('deleteProfilePage.deleteButton')" />
            </div>
        </div>
    </div>
</template>

<script>
import { useMainStore } from '@/store/mainStore';
import { useRouter } from 'vue-router';
import { deleteAccount } from '@/db/accountService';
import { useI18n } from 'vue-i18n';

function transliterate(text) {
    const ukToEnMap = {
        'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'H', 'Ґ': 'G', 'Д': 'D',
        'Е': 'E', 'Є': 'Ye', 'Ж': 'Zh', 'З': 'Z', 'И': 'Y', 'І': 'I',
        'Ї': 'Yi', 'Й': 'Y', 'К': 'K', 'Л': 'L', 'М': 'M', 'Н': 'N',
        'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U',
        'Ф': 'F', 'Х': 'Kh', 'Ц': 'Ts', 'Ч': 'Ch', 'Ш': 'Sh', 'Щ': 'Shch',
        'Ь': '', 'Ю': 'Yu', 'Я': 'Ya',
        'а': 'a', 'б': 'b', 'в': 'v', 'г': 'h', 'ґ': 'g', 'д': 'd',
        'е': 'e', 'є': 'ie', 'ж': 'zh', 'з': 'z', 'и': 'y', 'і': 'i',
        'ї': 'i', 'й': 'i', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
        'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
        'ф': 'f', 'х': 'kh', 'ц': 'ts', 'ч': 'ch', 'ш': 'sh', 'щ': 'shch',
        'ь': '\'', 'ю': 'iu', 'я': 'ia'
    };

    if (text) {
        return text.split('').map(char => ukToEnMap[char] || char).join('');
    } else {
        return text
    }
}

export default {
    name: 'DeleteProfileForm',

    setup() {
        const store = useMainStore();
        const router = useRouter();
        const { locale } = useI18n();

        const deleteSelectedProfile = async () => {
            if (store.profile_for_deletion === store.login) {
                store.setUserData(null);
                store.setUserInternetData(null);
                store.setUserTvData(null);
            }

            await deleteAccount(store.profile_for_deletion);

            router.push('/');
        }

        return {
            store,
            deleteSelectedProfile,
            locale,
            transliterate: transliterate
        }
    }
}
</script>

<style lang="scss">

.delete-profile-form {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
}

.delete-profile-view {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
}
</style>
